import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import parse, { DOMNode } from "html-react-parser";
import { parsedHtmlTransformation } from "../../../utils/html";
import PageImage from "../PageImage";
import { jsonParseString } from "../../../utils/string";
import { ContentType, ModelTransformation, ModelType } from "../../../types";
import _ from "lodash";
import BlogItem from "../Blog/BlogItem";
import { ImageDataLike } from "gatsby-plugin-image";

export interface CMSContentItemProps {
    model: Pick<ModelType, "id" | "name" | "modelId" | "transformations">;
    content: Partial<ContentType>;
    selectedTransformationId: string;
}

export default function CMSContentItem({ content, model, selectedTransformationId }: CMSContentItemProps) {

    const contentData = jsonParseString(content.data);
    const transformationMap = _.keyBy(model?.transformations, "id");
    const transformation = transformationMap[selectedTransformationId] as (ModelTransformation | undefined);

    if (transformation && transformation?.html) {
        let data = Object.fromEntries(Object.keys(contentData).map(key => [
            key.toLowerCase(),
            <FieldDisplay content={content} contentData={contentData} dataKey={key} />
        ]));
        return parsedHtmlTransformation(transformation.html, data);
    }

    return null;
}

const FieldDisplay = ({ content, contentData, dataKey }: { content: any, contentData: any, dataKey: string }) => {

    if (dataKey === "image") {
        return (
            <PageImage pageImage={content} />
        )
    }

    if (typeof contentData[dataKey] === "string") {
        return (
            <>{contentData[dataKey]}</>
        )
    }

    return (
        <></>
    )
}